import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast({ title: "Enter your email", variant: "destructive" });
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
      toast({ title: "Reset link sent", description: "Check your email for the password reset link" });
    } catch (error) {
      toast({ title: "Error", description: error.response?.data?.detail || "Failed to send reset link", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900" data-testid="forgot-title">Forgot Password</h1>
            <p className="text-gray-500 mt-1">
              {sent ? 'Check your email for the reset link' : 'Enter your email to receive a password reset link'}
            </p>
          </div>

          {!sent ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label>Email Address *</Label>
                <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@example.com" className="mt-1" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-[#D62828] hover:bg-[#B01F1F] text-white font-bold py-3">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </form>
          ) : (
            <div className="text-center py-4">
              <p className="text-green-600 font-semibold mb-4">A password reset link has been sent to your email.</p>
              <p className="text-sm text-gray-500">Didn't receive it? Check your spam folder or try again.</p>
              <Button onClick={() => setSent(false)} variant="outline" className="mt-4">
                Try again
              </Button>
            </div>
          )}

          <p className="text-center text-sm text-gray-500 mt-6">
            <Link to="/login" className="text-[#D62828] font-semibold hover:underline">Back to Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
